import { render } from "./Form.vue?vue&type=template&id=67154112&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=67154112&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67154112"

export default script